<template>
  <div class="main-pages">
    <div class="container-fluid p-4">
      <div
        class="w-100 d-flex flex-column align-items-center justify-content-between"
        style="padding: 24px; margin-top: 82px"
      >
        <span class="pageSteps card-styling">
          <p style="font-weight: 300; font-style: normal">Dashboard</p>
          <img
            style="margin: 0 17px"
            :src="require(`@/assets/images/svg/ícone-seta-direita-cinza.svg`)"
            alt=""
          />
          <p style="font-style: normal; font-weight: 500">Calendário</p>
        </span>
      </div>
      <div class="col-lg-12">
        <div class="cardCalendar">
          <vue-cal
            style="height: 100% !important; position: relative; z-index: 0"
            locale="pt-br"
            :time-from="9 * 60"
            :time-to="19 * 60"
            :time="false"
            :disable-views="['years', 'year', 'week', 'day']"
            :events="eventList"
            @view-change="fetchEvents"
            :active-view="view"
            events-on-month-view="true"
            :startWeekOnSunday="startWeekOnSunday"
            :clickable="false"
          >
            <!-- :on-event-click="onEventClick" -->
          </vue-cal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import apiGerenciarMidias from "../service/apiGerenciarMidiasService";
import moment from "moment";
import formatting from "../plugins/formatting";

export default {
  name: "Calendar",
  components: { VueCal },
  data() {
    return {
      selectedEvent: {},
      showDialog: false,
      view: "month",
      startWeekOnSunday: false,
      events: [],
      now: new Date(),
      startDate: "",
      endDate: "",
      recebeID: {
        id: "",
      },
    };
  },
  computed: {
    eventList() {
      return this.events;
    },
  },
  async created() {
    this.fetchEvents({
      view: "month",
      startDate: moment().startOf("month").format("YYYY-MM-DD HH:mm"),
      endDate: moment().endOf("month").format("YYYY-MM-DD HH:mm"),
      week: "",
    });
  },
  methods: {
    async fetchEvents({ view, startDate, endDate, week }) {
      this.view = view;
      this.startDate = startDate;
      this.endDate = endDate;

      let response = await apiGerenciarMidias.getScheduledMedias({
        startDate: moment(this.startDate).format("YYYY-MM-DD"),
        isCalendar: true,
      });

      if (response.status === 200) {
        this.events = response.data.data.map((element) => {
          let time = formatting.formatTime(element.scheduleDate);
          return {
            start: moment(element.scheduleDate).format("YYYY-MM-DD HH:mm"),
            end: moment(element.scheduleDate).format("YYYY-MM-DD HH:mm"),
            title: time,
            ...element,
          };
        });
      }
    },
  },
};
</script>

<style>
.vuecal__event {
  margin: auto;
  margin-bottom: 2px;
  width: 80%;
  border-radius: 25px;
  border: 1px solid var(--blue-medium);
  background-color: var(--blue-lightSecond);
  cursor: pointer !important;
}

.vuecal__now-line {
  color: var(--blue-medium);
}

.vuecal--month-view .vuecal__cell {
  min-height: 100px;
}

.vuecal__arrow {
  z-index: 0;
}

.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
  padding: 5px;
}

.vuecal__cell--current {
  background-color: var(--blue-lightSecond);
}

.cardCalendar {
  background: var(--white);
  padding: 27px;
  border-radius: 10px;
  margin: 20px;
}

.vuecal__flex .vuecal__weekdays-headings {
  font-size: 14px;
}

.vuecal__cell--out-of-scope {
  color: #00000040 !important;
}

.vuecal__cell {
  color: var(--passiveColor);
  font-size: 14px;
}

.vuecal__view-btn {
  color: var(--passiveColor);
}
</style>
